const ElementGroups = {
	block: "block",
	inline: "inline",
	listItem: "listItem",
	listItemContent: "listItemContent",
	list: "list",
	tab: "tab",
	galleryItem: "galleryItem",
	paragraph: "paragraph",
	answer: "questionAnswer",
};

export default ElementGroups;
